import { HudButton } from 'components/HudButton'
import { Settings } from 'lucide-react'
import React, { Dispatch, FC, SetStateAction } from 'react'

interface SettingsButtonProps {
  isSelected: boolean
  setIsSelected: Dispatch<SetStateAction<boolean>>
}

export const SettingsButton: FC<SettingsButtonProps> = (props) => {
  return (
    <HudButton
      icon={<Settings />}
      isSelected={props.isSelected}
      onClick={() => props.setIsSelected(!props.isSelected)}
      animation='scale'
      scaleAmount={1.1}
    />
  )
}
